import { Navigate } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const MarketWildcardPage = () => {
  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_MARKET, { sport: Sport.FOOTBALL })}
      replace
      keepParams
    />
  );
};
export default MarketWildcardPage;
